import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFaceIdentityBase } from '../utils/faceIdentityRoutes';
import './FaceIdentityHomeButton.css';

function HomeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  );
}

/**
 * Header home control for face-identity flow pages.
 * @param {{ onHome?: () => void, homePath?: string, className?: string }} props
 */
const FaceIdentityHomeButton = ({ onHome, homePath, className = '' }) => {
  const navigate = useNavigate();
  const fiBase = useFaceIdentityBase();
  const resolvedHome = homePath || fiBase;

  const handleHome = useCallback(() => {
    if (typeof onHome === 'function') {
      onHome();
      return;
    }
    navigate(resolvedHome, { replace: true });
  }, [navigate, onHome, resolvedHome]);

  return (
    <button
      type="button"
      className={`fi-home-button ${className}`.trim()}
      onClick={handleHome}
      aria-label="Go to home"
      title="Home"
    >
      <HomeIcon />
    </button>
  );
};

export default FaceIdentityHomeButton;
